<template>
  <!-- 积分商城-积分礼品 -->
  <div class="points_gift">
    <!-- 优惠券列表 -->
    <ul class="list" v-show="couponsIsShowfaly">
      <!-- <li class="wrap">
        <div class="item">
          <img src="../../assets/images/integralCenter/exchange_1.svg" alt="" />
          <span class="name">兑换优惠券</span>
          <button class="createBtn" @click="couponsChange(true, 1)">
            创建
          </button>
        </div>
      </li>
      <li class="wrap">
        <div class="item">
          <img src="../../assets/images/integralCenter/exchange_2.svg" alt="" />
          <span class="name">兑换实物</span>
          <button class="createBtn" @click="couponsChange(true, 2)">
            创建
          </button>
        </div>
      </li> -->
      <li class="wrap" v-for="item in tabList" :key="item.id">
        <div class="item">
          <img src="../../assets/images/integralCenter/exchange_2.svg" alt="" />
          <span class="name">{{ item.name }}</span>
          <button class="createBtn" @click="couponsChange(item.couponsNot, item.id)">
            创建
          </button>
        </div>
      </li>
    </ul>

    <!-- 创建积分优惠券 -->
    <create-coupons :isShow="couponsIsShow" :tabActive="tabActive" @return="couponsChange(false, 3)"></create-coupons>
    <!-- 创建积分优惠券 -->
    <create-coupons2 :isShow="couponsIsShow1" v-if="couponsIsShow1" :tabActive="tabActive" @returnback="returnback()"></create-coupons2>
  </div>
</template>

<script>
import createCoupons from "./create_coupons";
import createCoupons2 from "./create_coupons2";
import { getSellerInfo } from "@/api/sellerController";
export default {
  components: {
    createCoupons,
    createCoupons2,
  },
  data() {
    return {
      // 创建积分优惠券显示隐藏状态控制
      couponsIsShow: false,
      couponsIsShow1: false,
      couponsIsShowfaly: true,
      tabActive: 10,
      tabList: [
        // {
        //   name: "兑换优惠券",
        //   couponsNot: true,
        //   img: require("../../assets/images/integralCenter/exchange_1.svg"),
        //   type: 9,
        //   id: 1,
        // },
        // {
        //   name: "兑换实物",
        //   couponsNot: true,
        //   img: require("../../assets/images/integralCenter/exchange_2.svg"),
        //   type: 10,
        //   id: 2,
        // },
        // {
        //   name: "兑换京豆",
        //   couponsNot: true,
        //   img: require("../../assets/images/integralCenter/exchange_2.svg"),
        //   type: 29,
        //   id: 29,
        // },
        // {
        //   name: "兑换E卡",
        //   couponsNot: true,
        //   img: require("../../assets/images/integralCenter/exchange_2.svg"),
        //   type: 30,
        //   id: 30,
        // },
      ],
    };
  },
  created() {
    this.getSellerInfo();
  },
  methods: {
    // 玩法权限
    getSellerInfo() {
      getSellerInfo().then((res) => {
        this.showLoading = false;
        res.data.permissions.forEach((item) => {
          if (item === "integralMall:exchange:coupon") {
            this.tabList.push({
              sort: 10,
              name: "兑换优惠券",
              couponsNot: true,
              img: require("../../assets/images/integralCenter/exchange_1.svg"),
              type: 9,
              id: 1,
            });
          } else if (item === "integralMall:exchange:gift") {
            this.tabList.push({
              sort: 20,
              name: "兑换实物",
              couponsNot: true,
              img: require("../../assets/images/integralCenter/exchange_2.svg"),
              type: 10,
              id: 2,
            });
          } else if (item === "integralMall:exchange:bean") {
            this.tabList.push({
              sort: 30,
              name: "兑换京豆",
              couponsNot: true,
              img: require("../../assets/images/integralCenter/exchange_2.svg"),
              type: 29,
              id: 29,
            });
          } else if (item === "integralMall:exchange:ecard") {
            this.tabList.push({
              sort: 40,
              name: "兑换E卡",
              couponsNot: true,
              img: require("../../assets/images/integralCenter/exchange_2.svg"),
              type: 30,
              id: 30,
            });
          }
        });
        // 排序
        this.tabList.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
    /**
     * 优惠券组件显示隐藏 && 显示隐藏导航栏
     */
    couponsChange(flag, index) {
      //console.log(index);
      if (index < 4) {
        if (flag) {
          this.$emit("navTabChange", false);
          this.couponsIsShow = true;
          this.couponsIsShowfaly = false;
        } else {
          this.$emit("navTabChange", true);
          this.couponsIsShow = false;
          this.couponsIsShowfaly = true;
        }
        if (index == 1) {
          this.tabActive = 10;
        } else if (index == 2) {
          this.tabActive = 9;
        }
      } else {
        this.$emit("navTabChange", false);
        this.couponsIsShowfaly = false;
        this.couponsIsShow1 = true;
        this.tabActive = index;
      }
    },
    returnback() {
      this.$emit("navTabChange", true);
      this.couponsIsShow1 = false;
      this.couponsIsShowfaly = true;
    },
  },
};
</script>

<style scoped lang="scss">
.points_gift {
  min-width: 966px;
  min-height: 880px;

  .list {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 30px 20px;
    min-width: 1366px;
    .wrap {
      width: 16.6%;
      height: 240px;
      padding: 0 8px;
      margin-bottom: 20px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        border: 1px solid #eee;
        height: 100%;
        border-radius: 6px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 2px 2px 8px rgba(139, 156, 188, 0.15) !important;
        &:hover {
          // border: 1px solid #7B61FF;
          box-shadow: 2px 2px 16px rgba(86, 118, 179, 0.15) !important;
        }
        img {
          width: 60px;
          height: 46px;
          margin-top: 50px;
        }
        .name {
          margin-top: 40px;
          font-size: 16px;
          color: #333;
        }
        .createBtn {
          width: 92px;
          height: 32px;
          line-height: 28px;
          margin-top: 20px;
          text-align: center;
          outline: none;
          cursor: pointer;
          background-color: white;
          border-radius: 2px;
          border: 1px solid #7b61ff;
          color: #7b61ff;
          font-size: 14px;
          transition: all 0.2s;
          &:hover {
            background-color: #7b61ff;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
